export default __webpack_public_path__ + "android-character-symbol.png";